import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { storageKey } from '@/lib/storage-key.js';

import enCommon from './locales/en/common.json';
import enErrors from './locales/en/errors.json';
import enAuth from './locales/en/auth.json';
import enLobby from './locales/en/lobby.json';
import enCasino from './locales/en/casino.json';
import enWallet from './locales/en/wallet.json';
import enDeposit from './locales/en/deposit.json';
import enWithdraw from './locales/en/withdraw.json';
import enHistory from './locales/en/history.json';
import enPromo from './locales/en/promo.json';
import enProfile from './locales/en/profile.json';
import enSettings from './locales/en/settings.json';
import enKyc from './locales/en/kyc.json';
import enGames from './locales/en/games.json';
import enSpin from './locales/en/spin.json';
import enReferral from './locales/en/referral.json';
import enOriginals from './locales/en/originals.json';
import enSupport from './locales/en/support.json';

import thCommon from './locales/th/common.json';
import thErrors from './locales/th/errors.json';
import thAuth from './locales/th/auth.json';
import thLobby from './locales/th/lobby.json';
import thCasino from './locales/th/casino.json';
import thWallet from './locales/th/wallet.json';
import thDeposit from './locales/th/deposit.json';
import thWithdraw from './locales/th/withdraw.json';
import thHistory from './locales/th/history.json';
import thPromo from './locales/th/promo.json';
import thProfile from './locales/th/profile.json';
import thSettings from './locales/th/settings.json';
import thKyc from './locales/th/kyc.json';
import thGames from './locales/th/games.json';
import thSpin from './locales/th/spin.json';
import thReferral from './locales/th/referral.json';
import thOriginals from './locales/th/originals.json';
import thSupport from './locales/th/support.json';

import viCommon from './locales/vi/common.json';
import viErrors from './locales/vi/errors.json';
import viAuth from './locales/vi/auth.json';
import viLobby from './locales/vi/lobby.json';
import viCasino from './locales/vi/casino.json';
import viWallet from './locales/vi/wallet.json';
import viDeposit from './locales/vi/deposit.json';
import viWithdraw from './locales/vi/withdraw.json';
import viHistory from './locales/vi/history.json';
import viPromo from './locales/vi/promo.json';
import viProfile from './locales/vi/profile.json';
import viSettings from './locales/vi/settings.json';
import viKyc from './locales/vi/kyc.json';
import viGames from './locales/vi/games.json';
import viSpin from './locales/vi/spin.json';
import viReferral from './locales/vi/referral.json';
import viOriginals from './locales/vi/originals.json';
import viSupport from './locales/vi/support.json';

import zhCommon from './locales/zh/common.json';
import zhErrors from './locales/zh/errors.json';
import zhAuth from './locales/zh/auth.json';
import zhLobby from './locales/zh/lobby.json';
import zhCasino from './locales/zh/casino.json';
import zhWallet from './locales/zh/wallet.json';
import zhDeposit from './locales/zh/deposit.json';
import zhWithdraw from './locales/zh/withdraw.json';
import zhHistory from './locales/zh/history.json';
import zhPromo from './locales/zh/promo.json';
import zhProfile from './locales/zh/profile.json';
import zhSettings from './locales/zh/settings.json';
import zhKyc from './locales/zh/kyc.json';
import zhGames from './locales/zh/games.json';
import zhSpin from './locales/zh/spin.json';
import zhReferral from './locales/zh/referral.json';
import zhOriginals from './locales/zh/originals.json';
import zhSupport from './locales/zh/support.json';

import kmCommon from './locales/km/common.json';
import kmErrors from './locales/km/errors.json';
import kmAuth from './locales/km/auth.json';
import kmLobby from './locales/km/lobby.json';
import kmCasino from './locales/km/casino.json';
import kmWallet from './locales/km/wallet.json';
import kmDeposit from './locales/km/deposit.json';
import kmWithdraw from './locales/km/withdraw.json';
import kmHistory from './locales/km/history.json';
import kmPromo from './locales/km/promo.json';
import kmProfile from './locales/km/profile.json';
import kmSettings from './locales/km/settings.json';
import kmKyc from './locales/km/kyc.json';
import kmGames from './locales/km/games.json';
import kmSpin from './locales/km/spin.json';
import kmReferral from './locales/km/referral.json';
import kmOriginals from './locales/km/originals.json';
import kmSupport from './locales/km/support.json';

import loCommon from './locales/lo/common.json';
import loErrors from './locales/lo/errors.json';
import loAuth from './locales/lo/auth.json';
import loLobby from './locales/lo/lobby.json';
import loCasino from './locales/lo/casino.json';
import loWallet from './locales/lo/wallet.json';
import loDeposit from './locales/lo/deposit.json';
import loWithdraw from './locales/lo/withdraw.json';
import loHistory from './locales/lo/history.json';
import loPromo from './locales/lo/promo.json';
import loProfile from './locales/lo/profile.json';
import loSettings from './locales/lo/settings.json';
import loKyc from './locales/lo/kyc.json';
import loGames from './locales/lo/games.json';
import loSpin from './locales/lo/spin.json';
import loReferral from './locales/lo/referral.json';
import loOriginals from './locales/lo/originals.json';
import loSupport from './locales/lo/support.json';

import myCommon from './locales/my/common.json';
import myErrors from './locales/my/errors.json';
import myAuth from './locales/my/auth.json';
import myLobby from './locales/my/lobby.json';
import myCasino from './locales/my/casino.json';
import myWallet from './locales/my/wallet.json';
import myDeposit from './locales/my/deposit.json';
import myWithdraw from './locales/my/withdraw.json';
import myHistory from './locales/my/history.json';
import myPromo from './locales/my/promo.json';
import myProfile from './locales/my/profile.json';
import mySettings from './locales/my/settings.json';
import myKyc from './locales/my/kyc.json';
import myGames from './locales/my/games.json';
import mySpin from './locales/my/spin.json';
import myReferral from './locales/my/referral.json';
import myOriginals from './locales/my/originals.json';
import mySupport from './locales/my/support.json';

export const SUPPORTED_LOCALES = ['en', 'th', 'vi', 'zh', 'km', 'lo', 'my'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const NAMESPACES = [
  'common', 'errors', 'auth', 'lobby', 'casino', 'wallet',
  'deposit', 'withdraw', 'history', 'promo', 'profile', 'settings', 'kyc', 'games', 'spin', 'referral', 'originals', 'support',
] as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    ns: NAMESPACES as unknown as string[],
    defaultNS: 'common',
    resources: {
      en: { common: enCommon, errors: enErrors, auth: enAuth, lobby: enLobby, casino: enCasino, wallet: enWallet, deposit: enDeposit, withdraw: enWithdraw, history: enHistory, promo: enPromo, profile: enProfile, settings: enSettings, kyc: enKyc, games: enGames, spin: enSpin, referral: enReferral, originals: enOriginals, support: enSupport },
      th: { common: thCommon, errors: thErrors, auth: thAuth, lobby: thLobby, casino: thCasino, wallet: thWallet, deposit: thDeposit, withdraw: thWithdraw, history: thHistory, promo: thPromo, profile: thProfile, settings: thSettings, kyc: thKyc, games: thGames, spin: thSpin, referral: thReferral, originals: thOriginals, support: thSupport },
      vi: { common: viCommon, errors: viErrors, auth: viAuth, lobby: viLobby, casino: viCasino, wallet: viWallet, deposit: viDeposit, withdraw: viWithdraw, history: viHistory, promo: viPromo, profile: viProfile, settings: viSettings, kyc: viKyc, games: viGames, spin: viSpin, referral: viReferral, originals: viOriginals, support: viSupport },
      zh: { common: zhCommon, errors: zhErrors, auth: zhAuth, lobby: zhLobby, casino: zhCasino, wallet: zhWallet, deposit: zhDeposit, withdraw: zhWithdraw, history: zhHistory, promo: zhPromo, profile: zhProfile, settings: zhSettings, kyc: zhKyc, games: zhGames, spin: zhSpin, referral: zhReferral, originals: zhOriginals, support: zhSupport },
      km: { common: kmCommon, errors: kmErrors, auth: kmAuth, lobby: kmLobby, casino: kmCasino, wallet: kmWallet, deposit: kmDeposit, withdraw: kmWithdraw, history: kmHistory, promo: kmPromo, profile: kmProfile, settings: kmSettings, kyc: kmKyc, games: kmGames, spin: kmSpin, referral: kmReferral, originals: kmOriginals, support: kmSupport },
      lo: { common: loCommon, errors: loErrors, auth: loAuth, lobby: loLobby, casino: loCasino, wallet: loWallet, deposit: loDeposit, withdraw: loWithdraw, history: loHistory, promo: loPromo, profile: loProfile, settings: loSettings, kyc: loKyc, games: loGames, spin: loSpin, referral: loReferral, originals: loOriginals, support: loSupport },
      my: { common: myCommon, errors: myErrors, auth: myAuth, lobby: myLobby, casino: myCasino, wallet: myWallet, deposit: myDeposit, withdraw: myWithdraw, history: myHistory, promo: myPromo, profile: myProfile, settings: mySettings, kyc: myKyc, games: myGames, spin: mySpin, referral: myReferral, originals: myOriginals, support: mySupport },
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: storageKey('locale'),
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

// Keep <html lang> in sync whenever i18next resolves or changes the language
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
